import { jsx } from 'react/jsx-runtime';

const SvgArrowLineRight = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M16 6v12h2V6h-2ZM5.66 6l5 6-5 6h2.61l5-6-5-6H5.66Z" }) }));

export { SvgArrowLineRight as default };
//# sourceMappingURL=ArrowLineRight.es.js.map
